import {
  FaUniversity,
  FaFileInvoiceDollar,
  FaFileAlt,
  FaInfoCircle,
  FaNetworkWired
} from "react-icons/fa";
import { MdOutlineHearing } from "react-icons/md";

export const ALL_BUTTONS = [
  {
    title: "Portal de transparência",
    link: "/transparencia",
    description: "Acesse informações públicas",
    bg_color: "bg-blue-950",
    color: "text-white",
    icon: <FaUniversity />,
  },
  {
    title: "Serviços de Tributação",
    link: "http://rn.serrinha.tributario.aspec.com.br/portal/UC0084EmitirCertidao/T0084L-emitir-certidao.xhtml",
    description: "Pague e consulte tributos",
    bg_color: "bg-gray-200",
    color: "text-blue-950",
    icon: <FaFileInvoiceDollar />,
  },
  {
    title: "Serviço online de contracheque",
    link: "https://rh247.com.br/241350801/login",
    description: "Consulte seu contracheque",
    bg_color: "bg-gray-200",
    color: "text-blue-950",
    icon: <FaFileAlt />,
  },
  {
    title: "Canais de Comunicação",
    link: "/transparencia/canais-de-comunicacao",
    description: "Sistema eletrônico de informação ao cidadão",
    bg_color: "bg-gray-200",
    color: "text-blue-950",
    icon: <FaInfoCircle />,
  },
  {
    title: "Ouvidoria",
    link: "/transparencia/ouvidoria",
    description: "Ouvidoria",
    bg_color: "bg-gray-200",
    color: "text-blue-950",
    icon: <MdOutlineHearing />,
  },
  {
    title: "Carta de Serviços",
    link: "/transparencia/carta-de-servicos",
    description: "Acesse todos os serviços disponíveis",
    bg_color: "bg-gray-200",
    color: "text-blue-950",
    icon: <FaNetworkWired />,
  },
];

const ButtonGrid = ({ buttons = ALL_BUTTONS }) => {
  return (
    <div className="container mx-auto mt-4">
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        {buttons.map((button, index) => (
          <a href={button.link} key={index}>
            <div
              className={`object-cover object-center w-full h-36 mx-auto rounded-2xl ${button.bg_color} flex flex-col items-center justify-center`}
            >
              <div className={`text-5xl mb-2 ${button.color}`}>
                {button.icon}
              </div>

              <h5 className={`text-2xl font-bold ${button.color} mb-1`}>
                {button.title}
              </h5>
              <span className={`text-lg font-medium text-center ${button.color}`}>
                {button.description}
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ButtonGrid;
